import type { Point } from "@suse-o11y/point";
import { usePermanent } from "@suse-o11y/use-permanent";
import Konva from "konva";
import React from "react";

import { AssignNodeField } from "./_AssignNodeField";
import { Shape, type ShapeConfig } from "./Shape";

interface LineConfig extends ShapeConfig {
	points: ReadonlyArray<Point>;
}

export type LineProps = LineConfig;

export const Line: React.FC<LineProps> = ({ points, ...config }) => {
	const flatPoints = points.flatMap(({ x, y }) => [x, y]);
	const line = usePermanent(() => new Konva.Line({ points: flatPoints, ...config }));

	return (
		<Shape instance={line} {...config}>
			<AssignNodeField instance={line} method="points" serialize value={flatPoints} />
		</Shape>
	);
};
